import { render, staticRenderFns } from "./DocsStorage.vue?vue&type=template&id=eef55996&scoped=true"
import script from "./DocsStorage.vue?vue&type=script&lang=js"
export * from "./DocsStorage.vue?vue&type=script&lang=js"
import style0 from "./DocsStorage.vue?vue&type=style&index=0&id=eef55996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef55996",
  null
  
)

export default component.exports